import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

interface FeatureFlags {
  referral_program: boolean
  announcements: boolean
  notifications: boolean
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState<FeatureFlags>({
    referral_program: false,
    announcements: false,
    notifications: false
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadFeatureFlags()
  }, [])

  const loadFeatureFlags = async () => {
    try {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('feature_key, is_enabled')

      if (error) throw error

      const flagsMap: FeatureFlags = {
        referral_program: false,
        announcements: false,
        notifications: false
      }

      data?.forEach((flag) => {
        if (flag.feature_key in flagsMap) {
          flagsMap[flag.feature_key as keyof FeatureFlags] = flag.is_enabled
        }
      })

      setFlags(flagsMap)
    } catch (error) {
      console.error('Error loading feature flags:', error)
      // フォールバック: 環境変数を使用
      setFlags({
        referral_program: import.meta.env.VITE_REFERRAL_ENABLED === 'true',
        announcements: true,
        notifications: true
      })
    } finally {
      setLoading(false)
    }
  }

  return { flags, loading }
}
